
export default class UtilsCustomer {

  static getCustomerEmail() {
    try {
      return window.external.GetCurrentUserEmail();
    } catch(err){
      return kendo.parseQueryStringParams(document.location.search).mail;
    }
  }

  static getOrganizer(participants){
    if(!participants || participants.length == 0)
      return null;
    return participants.find(p => p.isOrganizer);
  }

  static getCustomerIdentity(customer){
    if(!customer)
      return "???";
    return customer.FirstName && customer.LastName ? customer.FirstName + ' ' + customer.LastName : customer.Email;
  }

  static getParticipantsList(participants, separator, excludeOrganizer) {
    let ortherParticipants = "";
    participants.forEach((p, i) => {
      if(!(excludeOrganizer && p.isOrganizer))
        ortherParticipants += (p.FirstName && p.LastName ? p.FirstName + ' ' + p.LastName : p.Email) + (i < participants.length-1 ? separator : ' ');
    });

    return ortherParticipants;
  }

  static hasParticipants(prop, value, participants) {
    return participants ? participants.filter(p => p[prop] != value && !p.isOrganizer).length > 0 : false;
  }

  static isParticipant(prop, value, participants) {
    return participants ? participants.find(p => p[prop] == value && !p.isOrganizer) != undefined : false;
  }

  static isOwner(prop, value, participants) {
    return participants ? participants.find(p => p[prop] == value && p.isOrganizer) != undefined : false;
  }
}
